import { Controller } from "@hotwired/stimulus"

const OPTED_IN_TEXT = "You will need to email " +
  "<a href=\"mailto:marketing@loopandtie.com\">marketing@loopandtie.com</a> " +
  "to resubscribe once you opt out"
const OPTED_OUT_TEXT = "Get all the latest updates from Loop & Tie by subscribing to marketing emails"

export default class extends Controller {
  static get targets() { return ["optIn", "description", "option"]; }

  connect() {
    this.toggleOptions();
  }

  sync() {
    this.descriptionTarget.innerHTML = this.optInTarget.checked ? OPTED_IN_TEXT : OPTED_OUT_TEXT;
    this.toggleOptions();
  }

  toggleOptions() {
    this.optionTargets.forEach(option => option.classList.toggle("hidden", !this.optInTarget.checked));
  }
}
